module.exports = __webpack_public_path__ + "static/media/allcall_marker.435dc3f1.svg";